import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import Swal from 'sweetalert2';

import { fileUploadAsync, } from '../../controllers/dataBase/actions';
import { fileModelGet, } from '../../models/main/files';
import {
    checkFile, dataTableLanguaje, documentMaxFilesMessageGet, formatBytes, buttonProcessGet, customFileNameGet, globalSettings, processEvaluateGet, responseGet, sendMessageCloseCurrentWindowAsync,
    styles, languageObjGet, isUndNullEmp, LoadingSection, awaitDelay
} from '../../helpers/settings';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { apartmentReceiptPaymentModelGet } from '../../models/payments/apartmentReceiptPayment';
import { apartmentReceiptPaymentFileModelGet } from '../../models/payments/apartmentReceiptPaymentFile';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'PaymentApartmentFiles';

export default function PaymentApartmentFiles({
    $ = {},
    auth = {},
    showModal = false,
    setShowModal = () => { },
    apartmentReceipt = apartmentReceiptModelGet({}),
    apartmentReceiptPayment = apartmentReceiptPaymentModelGet({}),
    apartmentReceiptPaymentFile = apartmentReceiptPaymentFileModelGet({}),
    setApartmentReceiptPaymentFile = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let dtRowObj = {};
    let headerObj = {};
    let swalProperties = {};
    const dtPaymentFilesId = 'dtPaymentFiles';
    const [filesAccept, setFilesAccept] = useState('');
    const [showLoading, setShowLoading] = useState({ files: false, });
    const { fileTypes: fileTypesObj, files, backend, } = globalSettings?.app;
    const { methods, } = backend;
    const { icons, labels, messages, } = globalSettings;
    const { documents, } = globalSettings?.app?.backend;
    const fileTypes = [
        ...fileTypesObj?.images,
        ...fileTypesObj?.filesOne,
        ...fileTypesObj?.filesTwo,
    ];

    const [isEditDelete, setIsEditDelete] = useState(false);
    const [objFind, setObjFind] = useState({ fileId: '', description: '', rowIndex: 0, processType: 0, subMethod: '', });
    const [btnApartmentreceiptPaymentFileAddDisabled] = useState(apartmentReceiptPayment?.concilationStatus === 'S');
    const [apartmentReceiptPaymentFileTwo, setApartmentReceiptPaymentFileTwo] = useState(apartmentReceiptPaymentFileModelGet({}));

    const controls = {
        buttons: {
            attachment: {
                className: 'btn btn-outline-info btn-file',
                defaultClassDisabled: 'btn btn-outline-info btn-file disabled',
                id: 'btnModalApartmentReceiptPaymentFileAttachment',
            },
            back: {
                className: 'btn btn-outline-success mx-1',
                id: 'btnModalApartmentReceiptPaymentFileBack',
            },
            open: {
                className: 'btn btn-outline-info mx-1',
                id: 'btnModalApartmentReceiptPaymentFileOpen',
            },
            delete: {
                className: 'btn btn-outline-danger',
                id: 'btnModalApartmentReceiptPaymentFileDelete',
            },
            close: {
                className: 'close btn-danger fas fa-window-close',
                id: 'btnModalApartmentReceiptPaymentFileClose',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            apartmentReceiptPaymentFiles: {
                inputs: {
                    search: {
                        id: `${dtPaymentFilesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPaymentFilesId}_length select`,
                        className: '',
                    },
                },
            },
        },
        icons: {
            attachment: {
                className: icons?.paperClip,
                id: 'icoModalApartmentReceiptPaymentFileAttachment',
            },
            back: {
                className: icons?.arrowAltCircleLeft,
                id: 'icoModalApartmentReceiptPaymentFileBack',
            },
            open: {
                className: icons?.fileAltFar,
                id: 'icoModalApartmentReceiptPaymentFileOpen',
            },
            delete: {
                className: icons?.trash,
                id: 'icoModalApartmentReceiptPaymentFileDelete',
            },
        },
        inputs: {
            attachment: {
                id: 'inputModalApartmentReceiptPaymentFileAttachment',
                className: 'form-control',
            },
        },
        spinners: {
            attachment: {
                className: '',
                id: 'spModalApartmentReceiptPaymentFileAttachment',
            },
            open: {
                className: '',
                id: 'spModalApartmentReceiptPaymentFileOpen',
            },
            delete: {
                className: '',
                id: 'spModalApartmentReceiptPaymentFileDelete',
            },
            back: {
                className: '',
                id: 'spModalApartmentReceiptPaymentFileBack',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region methods (partmentReceiptPaymentFile)
    const apartmentReceiptPaymenFileGetByIdAsync = async ({
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptPaymenFileGetByIdAsync';
        let response = responseGet();
        try {
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPaymentFiles}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentReceiptPaymenFileUpdateByIdAsync = async ({
        id = '',
        apartmentReceiptPaymentFile = apartmentReceiptPaymentFileModelGet({}),
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptPaymenFileUpdateByIdAsync';
        let response = responseGet();
        try {
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                apartmentReceiptPaymentFile: apartmentReceiptPaymentFile,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentReceiptPaymentFiles}/${id}`,
            }

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentReceiptPaymentFileOpenAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptPaymentFileOpenAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let fileLocal = fileModelGet({});
            let apartmentReceiptPaymentFileLocal = apartmentReceiptPaymentFileModelGet({});
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`
            }
            //#endregion response is warning
            //#endregion variables

            //#region find document
            setShowLoading({ files: true, });

            //#region apartment get receipt apartmentReceiptPayment file
            response = await apartmentReceiptPaymenFileGetByIdAsync({
                id: apartmentReceiptPaymentFileTwo?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ files: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            apartmentReceiptPaymentFileLocal = response?.result || {};
            setApartmentReceiptPaymentFile(apartmentReceiptPaymentFileLocal);
            //#endregion apartement receipt apartmentReceiptPayment file

            if (!isUndNullEmp({ data: apartmentReceiptPaymentFileLocal?.files, subMethod: currentMethod, })?.result && apartmentReceiptPaymentFileLocal?.files?.length > 0) {
                fileLocal = apartmentReceiptPaymentFileLocal?.files?.find(({ id, }) => id === objFind?.fileId);
                if (!isUndNullEmp({ data: fileLocal?.id, subMethod: currentMethod, })?.result) {
                    if (!isUndNullEmp({ data: fileLocal?.url, subMethod: currentMethod, })?.result) {
                        //#region check if file exists
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        dataObj = {
                            buildingId: apartmentReceiptPaymentFileLocal?.buildingId,
                            folder: backend?.documents?.apartmentReceiptPaymentFiles,
                            fileName: fileLocal?.id,
                            method: methods?.fileUrlDownloadGet,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlFiles}/`,
                        }

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ files: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        //#endregion check if file exists

                        window?.open(fileLocal?.url, '_blank');
                        setShowLoading({ files: false, });
                    } else {
                        setShowLoading({ files: false, });
                        responseIsWarning.msgText = `${messages?.theFileCannotBeLocated?.[languageObj?.id]}<br/>`;
                        responseIsWarning.msgText += `${labels?.file?.[languageObj?.id]}: <b>${objFind?.description}</b>`;
                        response = responseIsWarning;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }
                }
            } else {
                setShowLoading({ files: false, });
                responseIsWarning.msgText = `${messages?.theFileCannotBeLocated?.[languageObj?.id]}<br/>`;
                responseIsWarning.msgText += `${labels?.file?.[languageObj?.id]}: <b>${objFind?.description}</b>`;
                response = responseIsWarning;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion find document
        } catch (ex) {
            setShowLoading({ files: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const apartmentReceiptPaymentFileDeleteAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'apartmentReceiptPaymentFileDeleteAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.file?.[languageObj?.id]}: <b>${objFind?.description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region variables
                        let apartmentReceiptPaymentFileLocal = apartmentReceiptPaymentFile;
                        //#endregion variables

                        if (!isUndNullEmp({ data: apartmentReceiptPaymentFileLocal?.files, subMethod: currentMethod, })?.result &&
                            apartmentReceiptPaymentFileLocal?.files?.length > 0) {
                            //#region update data (apartment receipt apartmentReceiptPayment file)
                            response = await apartmentReceiptPaymenFileUpdateByIdAsync({
                                id: apartmentReceiptPaymentFileLocal?.id,
                                apartmentReceiptPaymentFile: apartmentReceiptPaymentFileLocal,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }

                            apartmentReceiptPaymentFileLocal = response?.result?.apartmentReceiptPaymentFile || {};
                            setApartmentReceiptPaymentFile(apartmentReceiptPaymentFileLocal);
                            setApartmentReceiptPaymentFileTwo(apartmentReceiptPaymentFileLocal);
                            //#endregion update data (apartment receipt apartmentReceiptPayment file)

                            //#region delete file (physical)
                            headerObj = {
                                headers: {
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                },
                            };

                            dataObj = {
                                buildingId: apartmentReceiptPaymentFileLocal?.buildingId,
                                folder: documents?.apartmentReceiptPaymentFiles,
                                fileName: objFind?.fileId,
                                method: methods?.fileDelete,
                                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlFiles}/`
                            };

                            result = await axios?.post(
                                dataObj?.url,
                                dataObj,
                                headerObj,
                            );

                            response = result?.data || {};

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }
                            //#endregion delete file (physical)

                            //#region delete file (logical)
                            apartmentReceiptPaymentFileLocal.files = apartmentReceiptPaymentFileLocal?.files?.filter(({ id, }) => id !== objFind?.fileId) || [];
                            //#endregion delete file (logical)

                            //#region update data (apartment receipt apartmentReceiptPayment file (delete file))
                            response = await apartmentReceiptPaymenFileUpdateByIdAsync({
                                id: apartmentReceiptPaymentFileLocal?.id,
                                apartmentReceiptPaymentFile: apartmentReceiptPaymentFileLocal,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }

                            apartmentReceiptPaymentFileLocal = response?.result?.apartmentReceiptPaymentFile || {};
                            setApartmentReceiptPaymentFile(apartmentReceiptPaymentFileLocal);
                            setApartmentReceiptPaymentFileTwo(apartmentReceiptPaymentFileLocal);
                            //#endregion update data (apartment receipt apartmentReceiptPayment file (delete file))
                        }

                        //#region apartment receipt apartmentReceiptPayment file (datatable)
                        $(`#${dtPaymentFilesId}`)?.DataTable()?.row(objFind?.rowIndex)?.remove()?.draw(true);
                        //#endregion apartment receipt apartmentReceiptPayment file (datatable)

                        //#region old code
                        // response.msgType = 0;
                        // response.msgText = `${messages?.fileDeletedSuccessFully?.[languageObj?.id]}<br/>`;
                        // response.msgText += `${labels?.file?.[languageObj?.id]}: <b>${objFind?.description}</b>`;
                        // await sendMessageCloseCurrentWindowAsync({
                        //     msgType: response?.msgType,
                        //     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        //     closeWindow: false,
                        //     urlGoTo: response?.urlGoTo,
                        //     auth: auth,
                        //     isLogout: false,
                        //     languageId: languageObj?.id,
                        //     subMethod: currentMethod,
                        // });
                        //#endregion old code

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            setShowLoading({ files: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion methods (partmentReceiptPaymentFile)

    //#region methods (others)
    const dataTablesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtPaymentFilesId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: labels?.file?.[languageObj?.id], width: '70%', },
                    { title: labels?.size?.[languageObj?.id], className: 'text-right', width: '25%', orderable: false, searchable: false, },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                lengthChange: false,
                order: [[0, 'asc'],],
                paging: false,
                responsive: true,
                searching: false,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtPaymentFilesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtPaymentFilesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case methods?.apartmentReceiptPaymentFileOpen:
                            setObjFind({ fileId: id, description: description, rowIndex: dtRowIndex, processType: 3, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.open?.id}`)?.trigger('click');
                            break;
                        case methods?.apartmentReceiptPaymentFileDelete:
                            setObjFind({ fileId: id, description: description, rowIndex: dtRowIndex, processType: 4, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.delete?.id}`)?.trigger('click');
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({
        isModalClose = false,
        subMethod = '',
    }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            //#region body show modal set
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
            //#endregion body show modal set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let isEditDelete = false;
            let filesAcceptLocal = '';
            //#endregion variables

            //#region dataTable set
            response = await dataTablesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataTable set

            //#region queryCode set
            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion queryCode set

            //#region set if edit, delete details
            isEditDelete = processEvaluateGet({
                object: apartmentReceiptPaymentFile,
                property: labels?.process?.en?.toLowerCase(),
                process: labels?.edit?.en?.toLowerCase(),
                subMethod: currentMethod,
            })?.result &&
                processEvaluateGet({
                    object: apartmentReceiptPaymentFile,
                    property: labels?.process?.en?.toLowerCase(),
                    process: labels?.delete?.en?.toLowerCase(),
                    subMethod: currentMethod,
                })?.result;
            setIsEditDelete(isEditDelete);
            //#endregion set if edit, delete details

            //#region data table load data
            apartmentReceiptPaymentFile?.files?.forEach((detail) => {
                //#region variables
                dtRowObj = {
                    customName: customFileNameGet({
                        fileName: detail?.name,
                        lengthStart: 0,
                        lengthReturn: 20,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    customSize: formatBytes({
                        bytes: detail?.size,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result,
                    processButtons: [
                        {
                            isVisible: true,
                            showDivider: false,
                            isEnabled: true,
                            methodName: backend?.methods?.apartmentReceiptPaymentFileOpen,
                            icon: icons?.folderOpen,
                            label: labels?.open?.[languageObj?.id],
                        },
                        {
                            isVisible: true,
                            showDivider: false,
                            isEnabled: apartmentReceiptPayment?.concilationStatus !== 'S' && isEditDelete,
                            methodName: backend?.methods?.apartmentReceiptPaymentFileDelete,
                            icon: icons?.trash,
                            label: labels?.delete?.[languageObj?.id],
                        },
                    ],
                }
                //#endregion variables

                //#region methods
                dtRows.push([
                    dtRowObj?.customName,
                    dtRowObj?.customSize,
                    buttonProcessGet({
                        id: detail?.id,
                        description: dtRowObj?.customName,
                        showDetails: false,
                        labelDetails: '',
                        enabledDetails: false,
                        showEdit: false,
                        labelEdit: '',
                        enabledEdit: false,
                        showDelete: false,
                        labelDelete: '',
                        enabledDelete: false,
                        processButtons: dtRowObj?.processButtons,
                        subMethod: currentMethod,
                    })?.result,
                ]);
                //#endregion variables
            });

            $(`#${dtPaymentFilesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            //#endregion data table load data

            //apartmentReceiptPaymentFileTwo = apartmentReceiptPaymentFile;
            setApartmentReceiptPaymentFileTwo(apartmentReceiptPaymentFile);

            //#region filesAccept set
            fileTypes?.forEach((detail, index) => {
                if ((index + 1) < fileTypes.length) {
                    filesAcceptLocal += `${detail}, `;
                } else {
                    filesAcceptLocal += `${detail}`;
                }
            });

            setFilesAccept(filesAcceptLocal);
            //#endregion filesAccept set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const fileAddAsync = async ({
        e = {},
        subMethod = '',
    }) => {
        const currentMethod = 'fileAddAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRow = [];
            let uidLocal = '';
            let urlFileLocal = '';
            let fileObjLocal = {};
            let fileFindLocal = [];
            let customNameLocal = '';
            let customSizeLocal = '';
            const fakePathValue = e?.target?.value;
            const fileLocal = e?.target?.files?.[0];
            //#endregion variables

            controlsStatusSet({ processType: 1, subMethod: currentMethod });

            //#region add file
            if (!isUndNullEmp({ data: fakePathValue, subMethod: currentMethod, })?.result) {
                //#region check file
                response = checkFile({
                    fileType: fileLocal?.type,
                    fileSize: fileLocal?.size,
                    fileAllowedTypes: fileTypes,
                    fileMaxSize: globalSettings?.app?.fileSize?.max,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    $(`#${controls?.inputs?.attachment?.id}`)?.val('');
                    controlsStatusSet({ processType: 0, subMethod: currentMethod });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion check file

                setApartmentReceiptPaymentFileTwo(isUndNullEmp({ data: apartmentReceiptPaymentFileTwo, subMethod: currentMethod, })?.result ?
                    apartmentReceiptPaymentFile :
                    apartmentReceiptPaymentFileTwo);
                fileFindLocal = apartmentReceiptPaymentFile?.files?.find(
                    ({ name, size, type, path, }) => name === fileLocal?.name && size === fileLocal?.size && type === fileLocal?.type && path === fakePathValue) || {};

                if (isUndNullEmp({ data: fileFindLocal, subMethod: currentMethod, })?.result) {
                    //#region check files maximum
                    if (apartmentReceiptPaymentFile?.files?.length >= files?.apartmentReceiptPaymentFileMaxFiles) {
                        response = documentMaxFilesMessageGet({
                            maxFiles: files?.apartmentReceiptPaymentFileMaxFiles,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            $(`#${controls?.inputs?.attachment?.id}`)?.val('');
                            controlsStatusSet({ processType: 0, subMethod: currentMethod });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                    }
                    //#endregion check files maximum

                    //#region upload file (new)
                    uidLocal = uuidv4();
                    customNameLocal = customFileNameGet({
                        fileName: fileLocal?.name,
                        lengthStart: 0,
                        lengthReturn: 20,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    customSizeLocal = formatBytes({
                        bytes: fileLocal?.size,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;

                    //#region upload file
                    response = await fileUploadAsync({
                        folder: documents?.apartmentReceiptPaymentFiles,
                        file: fileLocal,
                        fileName: uidLocal,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        $(`#${controls?.inputs?.attachment?.id}`)?.val('');
                        controlsStatusSet({ processType: 0, subMethod: currentMethod });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    urlFileLocal = response?.result || {};
                    //#endregion upload file
                    //#endregion upload file (new)

                    fileObjLocal = fileModelGet({
                        id: uidLocal,
                        name: fileLocal?.name,
                        nameCustom: customNameLocal,
                        path: fakePathValue,
                        size: fileLocal?.size,
                        sizeCustom: customSizeLocal,
                        type: fileLocal?.type,
                        url: urlFileLocal,
                    });

                    //#region update document
                    apartmentReceiptPaymentFileTwo?.files?.push(fileObjLocal);

                    //#region update document
                    response = await apartmentReceiptPaymenFileUpdateByIdAsync({
                        id: apartmentReceiptPaymentFileTwo.id,
                        apartmentReceiptPaymentFile: apartmentReceiptPaymentFileTwo,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        $(`#${controls?.inputs?.attachment?.id}`)?.val('');
                        controlsStatusSet({ processType: 0, subMethod: currentMethod });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    setApartmentReceiptPaymentFileTwo(response?.result?.apartmentReceiptPaymentFile || {});
                    setApartmentReceiptPaymentFile(response?.result?.apartmentReceiptPaymentFile || {});
                    //#endregion update document

                    //#region add dataTable row (Building documents)
                    //#region variables
                    dtRow = [];
                    dtRowObj = {
                        id: uidLocal,
                        customFileName: customFileNameGet({
                            fileName: fileLocal?.name,
                            lengthStart: 0,
                            lengthReturn: 20,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        processButtons: [
                            {
                                isVisible: true,
                                showDivider: false,
                                isEnabled: true,
                                methodName: backend?.methods?.apartmentReceiptPaymentFileOpen,
                                icon: icons?.folderOpen,
                                label: labels?.open?.[languageObj?.id]
                            },
                            {
                                isVisible: true,
                                showDivider: false,
                                isEnabled: true,
                                methodName: backend?.methods?.apartmentReceiptPaymentFileDelete,
                                icon: icons?.trash,
                                label: labels?.delete?.[languageObj?.id],
                            },
                        ],
                    };
                    //#endregion variables
                    dtRow.push(
                        customNameLocal,
                        customSizeLocal,
                        buttonProcessGet({
                            id: dtRowObj?.id,
                            description: dtRowObj?.customFileName,
                            showDetails: false,
                            labelDetails: labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: false,
                            labelEdit: labels?.edit?.[languageObj?.id],
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: labels?.delete?.[languageObj?.id],
                            enabledDelete: false,
                            processButtons: dtRowObj?.processButtons,
                            subMethod: currentMethod,
                        })?.result,
                    );

                    $(`#${dtPaymentFilesId}`)?.DataTable()?.row?.add(dtRow)?.draw(true);
                    //#endregion add dataTable row (Building documents)
                    //#endregion update document
                }
            }

            $(`#${controls?.inputs?.attachment?.id}`)?.val('');
            controlsStatusSet({ processType: 0, subMethod: currentMethod });
            //#endregion add file
        } catch (ex) {
            $(`#${controls?.inputs?.attachment?.id}`)?.val('');
            controlsStatusSet({ processType: 0, subMethod: currentMethod });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.attachment?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.attachment?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.open?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.open?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.delete?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0 && processType >= 3));
            // $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0 && processType >= 3));
            // $(`#${controls?.inputs?.expenseTemplateTotal?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.apartments?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType <= 2));
            // $(`#${controls?.dataTables?.apartments?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType <= 2));

            $(`#${controls?.dataTables?.apartmentReceiptPaymentFiles?.inputs?.search?.id}`)?.attr('readOnly', processType !== 0);
            $(`#${controls?.dataTables?.apartmentReceiptPaymentFiles?.selects?.entries?.id}`)?.attr('disabled', processType !== 0);

            // $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0 && processType >= 3));
            // $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0 && processType >= 3));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.attachment?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.open?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.delete?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, [apartmentReceiptPaymentFile?.id])//eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })} show={showModal}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.document?.[languageObj?.id]}
                        src={globalSettings?.images?.documentLogo}
                        style={styles?.cardHeaderLogo}>
                    </img> - {labels?.paymentSupports?.[languageObj?.id]}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>

            <Modal.Body>
                <div className='row'>
                    <div className='col-md-12'>
                        <LoadingSection alt='loadingSection'
                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                            showText={true}
                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                            height={25}
                            hidden={!showLoading?.files}
                            width={25}
                            languageId={languageObj?.id}
                            subMethod={currentMethod} />

                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                            <table id={dtPaymentFilesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div className='form-group text-right'>
                    <div id={controls?.buttons?.attachment?.id}
                        className={(btnApartmentreceiptPaymentFileAddDisabled || !isEditDelete) ?
                            controls?.buttons?.attachment?.defaultClassDisabled :
                            controls?.buttons?.attachment?.className}>
                        <i id={controls?.icons?.attachment?.id} className={controls?.icons?.attachment?.className} /> <span id={controls?.spinners?.attachment?.id} className='' aria-hidden='true'></span>
                        <input id={controls?.inputs?.attachment?.id}
                            accept={filesAccept}
                            tooltip='tooltip'
                            title={labels?.toAttach?.[languageObj?.id]}
                            type='file'
                            name='attachment'
                            onChange={(e) => fileAddAsync({ e: e, subMethod: 'input - addFile', })} />
                    </div>
                    <button id={controls?.buttons?.open?.id}
                        className={controls?.buttons?.open?.className}
                        disabled={apartmentReceiptPaymentFile?.files?.length <= 0}
                        hidden={true}
                        title={labels?.open?.[languageObj?.id]}
                        onClick={(e) => apartmentReceiptPaymentFileOpenAsync({ e: e, subMethod: 'bt - fileOpen' })}
                        type='button'>
                        <i id={controls?.icons?.open?.id} className={controls?.icons?.open?.className} /> <span id={controls?.spinners?.v?.id} className='' aria-hidden='true'></span>
                    </button>
                    <button id={controls?.buttons?.delete?.id}
                        className={controls?.buttons?.delete?.className}
                        disabled={(btnApartmentreceiptPaymentFileAddDisabled || !isEditDelete)}
                        hidden={true}
                        title={labels?.delete?.[languageObj?.id]}
                        onClick={(e) => apartmentReceiptPaymentFileDeleteAsync({ e: e, subMethod: 'btn - fileDelete', })}
                        type='button'>
                        <i id={controls?.icons?.delete?.id} className={controls?.icons?.delete?.className} /> <span id={controls?.spinners?.delete?.id} className='' aria-hidden='true'></span>
                    </button>
                    <button id={controls?.buttons?.back?.id}
                        className={controls?.buttons?.back?.className}
                        tooltip='tooltip'
                        title={labels?.close?.[languageObj?.id]}
                        type='button'
                        onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                        <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}